<template>
    <section class="py-12">
        <div class="container mx-auto">
            <div class="grid items-center grid-cols-2 gap-6">
                <div class="col-span-1">
                    <h1 class="text-5xl text-dim_dark leading-tight w-fit border-b-[6px] border-dim_gold pb-4 mb-4">
                        <span class="text-dim_gold_txt"> NEVADO PREMIER</span> — <br>
                        роскошь премиальных <br>
                        современных <br>
                        натяжных потолков
                    </h1>
                    <p class="text-lg text-dim_regular mb-12">
                        <span class="mdi mdi-map-marker text-dim_gold_2 "></span>
                        Работаем в Санкт — Петербурге и в Москве
                    </p>
                    <p class="text-2xl text-dim_regular mb-12">
                        Наши потолки нового поколения <br>
                        подстраиваются под любой дизайн — проект, <br>
                        поэтому мы с легкостью воплотим ваши даже <br>
                        самые заветные мечты!
                    </p>
                    <button class="col-start-2 px-20 rounded py-4 text-xl text-black bg-dim_gold_2 border border-solid border-dim_gold_2 hover:border-black hover:bg-transparent">
                        Оставить заявку
                    </button>
                </div>
                <div class="col-span-1">
                    <div class="w-full h-[80vh] bg-center bg-cover bg-no-repeat bg-[url('https://premier.nevado.ru/dist/hero-slider-5.png?57b7f91c46bc47d231a44e4ba8a9eadc')]"></div>
                </div>
            </div>
        </div>
    </section>
</template>